import socketio from 'socket.io-client';
import config from '../../../config';

let sio;
let storeDispatch;
let storeGetters;
export default {
  socketEnabled() {
    return storeGetters.getCompanyConfig.socket.enabled;
  },
  contentEncoding() {
    return storeGetters.getCompanyConfig.socket.contentEncoding || 'clearText';
  },
  instance({ dispatch, getters }) {
    storeDispatch = dispatch;
    storeGetters = getters;

    if (!sio && this.socketEnabled()) {
      const socketOptions = {
        forceNew: true,
        transports: ['websocket'],
      };

      const cpv = storeGetters.getCpvUuid;
      const socketBaseUrl = config.API.socket[config.env];
      const contentEncoding = this.contentEncoding();
      const socketUrl = `${socketBaseUrl}?product=prematch&protocol=sio1&contentEncoding=${contentEncoding}&cpv=${cpv}`;

      sio = socketio(socketUrl, socketOptions);
      sio.on('message', message => storeDispatch('socketMessage', message));
      sio.on('connect', () => storeDispatch('handleSocketConnect'));
    }

    return sio;
  },
  connect() {
    if (sio && this.socketEnabled()) sio.connect();
  },
  disconnect() {
    if (sio && this.socketEnabled()) sio.disconnect();
  },
  emit({
    event,
    options,
  }) {
    if (this.socketEnabled()) {
      const device = storeGetters.getDevice;
      const company = storeGetters.getCompany;
      switch (event) {
        case 'subscribe':
          sio.emit(event, {
            language: company.locale || 'en',
            deliveryPlatform: 'Terminal',
            deviceUuid: device.deviceUuid,
          });
          break;
        case 'message':
          sio.emit(event, {
            type: options.type,
            data: options.data,
          });
          break;
        default:
      }
    }
  },
};
